//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drafting.js";
import "../no/Object.js";
import "../no/DraftingManager.js";
let d=[[],[[[],"CreatePrimaryContentItemBuilder",{R_:{builder:"Drafting.PrimaryContentItemBuilder"}},0,0],[[],"CreateAttributeItemBuilder",{R_:{builder:"Drafting.AttributeItemBuilder"}},0,0],[["isEditing"],"CreateDrawingCreationWizardBuilder",{R_:{builder:"Drafting.DrawingCreationWizardBuilder"}},1,0],[["className"],"CreateDrawingCreationWizardBuilderFromRule",{R_:{builder:"Drafting.DrawingCreationWizardBuilder"}},1,0],[[],"CreatePreferencesBuilder",{R_:{builder:"Drafting.AutomationPreferencesBuilder"}},0,0],[[],"CreateAnnotateViewsBuilder",{R_:{builder:"Drafting.AnnotateViewsBuilder"}},0,0],[[],"CreateRulesBuilder",{R_:{builder:"Drafting.RulesBuilder"}},0,0],[[],"CreateSpecifyRuleBuilder",{R_:{builder:"Drafting.SpecifyRuleBuilder"}},0,0],[[],"CreateDistributeAnnotationsBuilder",{R_:{builder:"Drafting.DistributeAnnotationsBuilder"}},0,0],[["numTags","remainingParts","numFileSpecs","remainingPartFileSpecs"],"GetRemainingPartsOfBooklet",{},0,0]],[["DrawingRegions","Drawings.DrawingRegionCollection",0]]];
SPLM.Drafting.AutomationManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drafting.AutomationManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;